<template>
  <transition name="toast-slide">
    <div v-if="visible" class="app-toast" :class="[`app-toast--${type}`, `app-toast--${position}`]" role="alert">
      <i :class="icon"></i>
      <span>{{ message }}</span>
      <button class="app-toast-close" @click="hide"><i class="bi bi-x"></i></button>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AppToast',
  data() {
    return {
      visible: false,
      message: '',
      type: 'success',
      position: 'bottom',
      timer: null
    };
  },
  computed: {
    icon() {
      const icons = {
        success: 'bi bi-check-circle-fill',
        danger:  'bi bi-x-circle-fill',
        warning: 'bi bi-exclamation-triangle-fill',
        info:    'bi bi-info-circle-fill'
      };
      return icons[this.type] || icons.info;
    }
  },
  mounted() {
    window.addEventListener('app:toast', this.onToast);
  },
  beforeUnmount() {
    window.removeEventListener('app:toast', this.onToast);
  },
  methods: {
    onToast(e) {
      const { message, type, position, duration } = e.detail;
      this.message = message || 'Operación completada';
      this.type = type || 'success';
      this.position = position || 'bottom';
      this.visible = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(this.hide, duration || 3500);
    },
    hide() {
      this.visible = false;
      clearTimeout(this.timer);
    }
  }
};
</script>

<style scoped>
.app-toast {
  position: fixed;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.75rem 1.1rem;
  border-radius: 10px;
  font-size: 0.875rem;
  font-weight: 500;
  min-width: 240px;
  max-width: 520px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.15);
  color: #fff;
}

.app-toast--bottom {
  bottom: 1.5rem;
  right: 1.5rem;
}

.app-toast--top {
  top: 1.25rem;
  left: 50%;
  transform: translateX(-50%);
}

.app-toast--success { background: #22863a; }
.app-toast--danger  { background: #c0392b; }
.app-toast--warning { background: #d68910; }
.app-toast--info    { background: #1272c4; }

.app-toast i { font-size: 1rem; flex-shrink: 0; }

.app-toast span { flex: 1; line-height: 1.3; white-space: pre-line; }

.app-toast-close {
  background: none;
  border: none;
  color: rgba(255,255,255,0.8);
  cursor: pointer;
  padding: 0;
  font-size: 1rem;
  flex-shrink: 0;
  line-height: 1;
}
.app-toast-close:hover { color: #fff; }

.toast-slide-enter-active.app-toast--top { animation: toast-in-top 0.25s ease-out; }
.toast-slide-leave-active.app-toast--top { animation: toast-in-top 0.2s ease-in reverse; }

.toast-slide-enter-active.app-toast--bottom { animation: toast-in-bottom 0.25s ease-out; }
.toast-slide-leave-active.app-toast--bottom { animation: toast-in-bottom 0.2s ease-in reverse; }

@keyframes toast-in-top {
  from { opacity: 0; transform: translateX(-50%) translateY(-12px); }
  to   { opacity: 1; transform: translateX(-50%) translateY(0); }
}

@keyframes toast-in-bottom {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
}
</style>
